// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"154":"bindData","810":"verifyIdentity"}[chunkId] || chunkId) + "." + {"154":"fbcedc90","597":"fe0b4e4d","810":"c41ec4e6"}[chunkId] + ".js";
};